// stores/GlobalStore.ts
import { computed, observable, action } from 'mobx';
import { PAGE_STAGE } from '@src/constants/business';
import ZtServiceFactory from '@src/services/zt';
import BGMStore from '@src/business-components/bgm/store';
import maskString from '@src/utils/mask-string';
import reload from '@src/utils/reload';

class AppointmentStageLogin {
  constructor(props) {
    this.context = props.$main;
  }

  $ztService = ZtServiceFactory.getDefaultInstance();

  /** 更新当前登录账号信息 */
  setAccountInfo = email => {
    if (email) {
      // 海外登录账号为邮箱
      const maskedEmail = email.replace(/(\d{3})\d{4}(\d{3})/, '$1***$2');

      this.context.accountInfo = maskedEmail;
    }
  };

  /**退出登录 */
  exitAccount = async () => {
    try {
      await this.$ztService.logout();
      this.context.accountInfo = null;
    } catch (error) {
      console.log('error', error);
    }
  };
}

class DownloadStageLogin {
  constructor(props) {
    this.context = props.$main;
  }

  $ztService = ZtServiceFactory.getDefaultInstance();

  /** 更新当前登录账号信息 */
  setAccountInfo = () => {
    this.context.accountInfo = window.XPASS?.$accountStore?.desensitizationEmail || maskString(window.XPASS?.$accountStore?.passportId);
  };

  /**退出登录 */
  // @autobind
  // exitAccount() {
  //   if (window.XPASS) {
  //     window.XPASS.exit().then(() => {
  //       window.location.reload();
  //     });
  //   }
  // }

  /**退出登录 */
  exitAccount = async () => {
    try {
      if (window.XPASS) {
        await window.XPASS.exit();
      }
      await this.$ztService.logout();
      reload();
    } catch (error) {
      console.log('error', error);
    }
  };
}

class GlobalStore {
  // 背景音乐
  @observable
  bgm = new BGMStore({
    audioSrc: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1749450843923_BGM_UPGRADE(D)_48k24b.mp3',
    musicIconRotate: false
  });

  // 最近一次背景音乐的播放状态
  @observable lastBgmState = false;

  /**顶栏是否吸顶 */
  @observable navbarStick = false;

  // 是否预约阶段
  @observable inAppointmentTime = -1;

  // 是否下载阶段
  @observable inDownloadTime = 1;

  /**帐户信息 */
  @observable accountInfo = null;

  /**预约阶段开放福利码 */
  @observable isInSubscribeCodeTime = -1;

  /**下载阶段开放福利码 */
  @observable downLoadGetCodeStatus = -1;

  @observable appointmentCount = undefined;

  // 顶栏是否展示下载按钮
  @observable showNavbarDownloadBtn = true;

  /**预约阶段登录 */
  AppointmentStageLogin = new AppointmentStageLogin({ $main: this });

  /**下载阶段登录 */
  DownloadStageLogin = new DownloadStageLogin({ $main: this });

  /**是否为下载阶段 */
  @computed
  get isDownloadStage() {
    return this.inDownloadTime === PAGE_STAGE.download.isOpen;
  }

  /**是否为预约阶段 */
  @computed
  get isAppointmentStage() {
    return !this.isDownloadStage;
  }

  /**是否为默认阶段（只有预约的阶段，没有礼包领取） */
  @computed
  get isNormalStage() {
    return this.isAppointmentStage && +this.isInSubscribeCodeTime === 0;
  }

  @computed
  get authServise() {
    // if (this.isNormalStage) {
    //   return {
    //     setAccountInfo: () => {}
    //   };
    // }
    // if (this.isAppointmentStage) {
    //   return this.AppointmentStageLogin;
    // }
    // if (this.isDownloadStage) {
    //   return this.DownloadStageLogin;
    // }
    return this.DownloadStageLogin;
  }

  @action
  toggleNavBarStickState(state) {
    this.navbarStick = state;
  }

  /**
   * 更改背景音乐状态
   * @param {boolean} state 是否播放
   */
  toggleBgmState(state) {
    this.bgm.handleChange(state);
  }

  /**
   * 记录背景音乐最近一次的播放状态
   */
  recordLastBgmState() {
    this.lastBgmState = this.bgm.isPlaying;
  }
}

// 创建全局 Store 实例（单例模式）
const globalStore = new GlobalStore();

export default globalStore;
